enum LocationPaymentType {
  CashierOnly = 0,
  CreditCard = 1,
}

export { LocationPaymentType };
